import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import { UiTextArea, UiInput, UiButton, UiSelect, UiRSelect } from "../ui";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useLocation } from "react-router-dom";




const RMassign = NiceModal.create(
  ({ id, rm_name }) => {
    const [state, setState] = useState({});
    const modal = useModal();
    const schema = yup.object().shape({
      rm: yup.mixed().nullable().required("This is required field"),


    });
    const {
      register,
      handleSubmit,
      control,
      watch,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });

    const onSubmitHandler = async (data) => {
      SaveData();
      //reset();
    };
    var SaveData = (e) => {
      setState({ ...state, loader: true });
      var form = document.querySelector("#rmform");
      var data = new FormData(form);

      instance({
        method: "post",
        url: "/z_update_rm",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true, rm_name: response.data.rm_name, rm_mobile: response.data.rm_mobile });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };
    useEffect(() => {




      instance
        .get("/z_get_rm")
        .then(function (response) {
          const selected = response.data.items.filter((item) => item.label == rm_name);
          setState({ ...state, items: response.data.items, selected: selected });
          reset({ rm: selected[0] });
        })
        .catch(function (error) { })
        .then(function () { });

      if (id) {
        reset({ id: id });
      }

    }, []);

    const location = useLocation();
    useEffect(() => {
      if (modal.visible == true) {
        modal.hide();
      }
    }, [location]);


    const watch_status = watch('status');
    return (
      <BootstrapModal {...bootstrapDialog(modal)} >
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Assign Account Manager</BootstrapModal.Title>
        </BootstrapModal.Header>
        <form id="rmform" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
          <BootstrapModal.Body>





            <Controller
              name="rm"
              control={control}
              render={({ field }) => (

                <UiRSelect
                  //defaultValue={state.selected}
                  options={state.items}
                  className=""
                  message={errors.rm?.message}
                  label="Account Manager"
                  {...field}
                />

              )}
            />


            <input type="hidden" name="id" {...register("id")}></input>




          </BootstrapModal.Body>
          <BootstrapModal.Footer>
            <UiButton loading={state["loader"]} title="Save" />
            <a className="btn btn-secondary" onClick={modal.hide}>Cancel</a>
          </BootstrapModal.Footer>
        </form>
      </BootstrapModal>
    );
  }
);

export default RMassign;
